<template>
  <div id="app">
    <Navbar />
    <div id="page-content"><router-view /></div>
    <Footer />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class App extends Vue {
  setMobileState() {
    this.$root.$data.isMobile = window.innerWidth <= 800;

    if (window.innerWidth <= 800) {
      this.$root.$data.isMobile = true;
      $('html').addClass('mobile');
    } else {
      this.$root.$data.isMobile = false;
      $('html').removeClass('mobile');
    }
  }

  created() {
    if (
      'ontouchstart' in document.documentElement ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    ) {
      $('body').addClass('mobile-device');
    }

    this.setMobileState();

    window.addEventListener('resize', this.setMobileState);

    // window.addEventListener('scroll', e => {
    //   console.log(e);
    // });

    // $(document).on('scroll', e => {
    //   console.log('HI BODY');
    //   e.preventDefault();
    //   console.log('preventDefault');
    // });

    // $('body').on('touchmove', function(e) {
    //   console.log('touchmove');
    //   e.preventDefault();
    // });
  }

  destroyed() {
    window.removeEventListener('resize', this.setMobileState);
  }
}

export default App;
</script>

<style lang="scss">
@import 'vars';

@font-face {
  font-family: 'DayCare';
  font-style: normal;
  font-weight: 200;
  src: url('assets/fonts/DayCare-Regular.otf');
}

@font-face {
  font-family: 'Kidzonia';
  font-style: normal;
  font-weight: 200;
  src: url('assets/fonts/Kidzonia.ttf');
}

html {
  font-family: 'DayCare';
  color: white;
  background-color: #4faeff;

  &.no-scroll {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
}

body {
  margin: 0;

  @include no-scroll {
    height: 100%;
    padding: 0;
    overflow: auto;
    margin: 0;
    -webkit-overflow-scrolling: touch;
  }
}

#app {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100vw;
  // height: 100vh;
  // background: linear-gradient(#0e89ff, #00ccff);
}

#page-content {
  background-color: #f3f3f3;
}

h1 {
  margin: 0.5em 0;
  font-size: 80px;
  z-index: 100;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.35);
}

h2 {
  margin: 0.5em 0;
  font-size: 50px;
  z-index: 100;
  // text-shadow: 0 4px 15px rgba(0, 0, 0, 0.35);
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

@media only screen and (max-width: 600px) {
  h2 {
    font-size: 40px;
  }
}

h3 {
  margin: 0.5em 0;
  font-size: 30px;
  z-index: 100;
  // text-shadow: 0 4px 15px rgba(0, 0, 0, 0.35);
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

button {
  outline: none !important;
}

// App Selectors

.content-section {
  width: 100vw;
  position: relative;

  p {
    font-size: 24px;
  }

  &.reg {
    > div {
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      padding: 120px 20px 120px;
      position: relative;
      z-index: 1;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: url(~@/assets/images/section-background.png);
      opacity: 0.9;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue